import { render, staticRenderFns } from "./addCardPayment.vue?vue&type=template&id=8cfe8cee"
import script from "./addCardPayment.vue?vue&type=script&lang=js"
export * from "./addCardPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports